import { createQuery } from "../../../../../util/graphql";
import PerformLoginForUser from "./PerformLoginForUser.graphql";

export const loginUser = ({ endpoint, clientSlug, email, password }) =>
  createQuery(endpoint, clientSlug)(PerformLoginForUser, {
    email,
    password
  });
